<template>
  <div class="basketball_teamDetail_matchPanel">
    <div class="row1">
      <span class="row1_left">
        <span
          class="row1Left_cloumn1"
          :class="baseInfor.teamLogo ? 'isLogo' : ''"
        >
          <img v-if="baseInfor.teamLogo" :src="baseInfor.teamLogo" />
        </span>
        <span class="row1Left_cloumn2">
          <span
            class="row1Left_cloumn2_row1"
            v-text="_valFormatHandler(baseInfor.teamName)"
          ></span>
          <span class="row1Left_cloumn2_row2">
            <span
              class="winLossText"
              v-text="
                `${_valFormatHandler(
                  baseInfor.teamWin,
                  '胜'
                )}${_valFormatHandler(baseInfor.teamLosses, '负')}`
              "
            ></span>
            <span
              class="teamRankText"
              v-text="baseInfor.teamRank ? '联赛第' + baseInfor.teamRank : ''"
            ></span>
          </span>
        </span>
      </span>

      <span class="row1_right">
        <span
          class="row1Right_cloumn"
          v-for="item in averageArr"
          :key="item.key"
        >
          <span
            class="row1Right_cloumn_row1"
            v-text="_valFormatHandler(item.rank)"
          ></span>
          <span
            class="row1Right_cloumn_row2"
            v-text="_valFormatHandler(item.val)"
          ></span>
          <span
            class="row1Right_cloumn_row3"
            v-text="_valFormatHandler(item.name)"
          ></span>
        </span>
      </span>
    </div>
  </div>
</template>

<script>
import cup_base_data_mixin from '@mixins/cup_base_data'
export default {
  name: 'basketball_teamDetail_matchPanel',
  mixins: [cup_base_data_mixin],
  props: {
    baseInfor: {
      type: Object,
      default: () => ({
        teamId: '',
        teamName: '',
        teamLogo: '',
        teamWin: '',
        teamLosses: '',
        teamRank: '',
      }),
    },
    averageArr: {
      type: Array,
      default: () => {
        return []
      },
    },
  },
  data() {
    return {}
  },
  methods: {
    _valFormatHandler(val, ceil) {
      let data
      if (val === undefined || val === null || val === '' || val === ' ') {
        return '-'
      }
      data = `${val}${ceil ? ceil : ''}`
      return data
    },
  },
}
</script>

<style lang="scss" scoped>
.basketball_teamDetail_matchPanel {
  position: relative;
  height: 15vw;
  padding-top: 1.88vw;
  width: 100%;
  display: flex;
  display: -webkit-flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
  .row1 {
    width: 100%;
    height: 8.33vw;
    display: flex;
    display: -webkit-flex;
    justify-content: center;
    align-items: center;
    .row1_left,
    .row1_right {
      display: flex;
      display: -webkit-flex;
      align-items: center;
    }
    .row1_left {
      width: 27.78vw;
      justify-content: flex-start;
      .row1Left_cloumn1 {
        display: block;
        width: 8.33vw;
        height: 8.33vw;
        background-size: 100% auto;
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center top;
        background-image: var(--mixtmt_default_teamLogo);
        &.isLogo {
          background-image: none;
        }
        img {
          display: block;
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      }
      .row1Left_cloumn2 {
        width: calc(100% - 8.33vw);
        padding-left: 1.388vw;
        display: flex;
        display: -webkit-flex;
        justify-content: center;
        align-items: flex-start;
        flex-direction: column;
        color: var(--mixtmt_whiteColor);
        .row1Left_cloumn2_row1 {
          display: flex;
          display: -webkit-flex;
          justify-content: flex-start;
          align-items: flex-start;
          width: 100%;
          height: auto;
          min-height: 3.25vw;
          font-size: 1.388vw;
          font-weight: bold;
        }
        .row1Left_cloumn2_row2 {
          width: 100%;
          display: flex;
          display: -webkit-flex;
          justify-content: flex-start;
          align-items: flex-start;
          flex-direction: column;
          .winLossText,
          .teamRankText {
            display: inline-block;
            width: auto;
            padding: 0 0.694vw;
            font-size: 1.11vw;
            line-height: 1.25vw;
            color: var(--mixtmt_whiteColor);
            /* background-color: var(--mixtmt_greyColor2); */
            /* border-radius: 1.25vw; */
          }
        }
      }
    }
    .row1_right {
      width: calc(100% - 27.78vw);
      justify-content: flex-end;
      .row1Right_cloumn {
        position: relative;
        flex: 1;
        /* max-width: 11.1vw; */
        display: flex;
        display: -webkit-flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        color: var(--mixtmt_whiteColor);
        text-align: center;
        &::before {
          position: absolute;
          content: '\20';
          left: 0;
          top: 50%;
          z-index: 2;
          width: 1px;
          height: 50%;
          background-color: var(--mixtmt_whiteColor);
          transform: translateY(-50%);
        }
        &:first-child::before {
          visibility: hidden;
        }
        .row1Right_cloumn_row1 {
          width: 100%;
          font-size: 1.25vw;
          font-weight: bold;
          padding-bottom: 0.347vw;
        }
        .row1Right_cloumn_row2,
        .row1Right_cloumn_row3 {
          width: 100%;
          font-size: 1.11vw;
        }
      }
    }
  }
}

.mixtmt_pc .basketball_teamDetail_matchPanel {
}
</style>
